import { useCallback, useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';

import { api } from '../../api';
import { FullPageLoader } from '../../components/Loader/Loader';
import AuthService from '../../services/AuthService';
import { PATHS } from '../../views/hub/auth2/SignUp';

export type LeadRerouterProps = {
  children: React.ReactNode;
};

const LeadRerouter = ({ children }: LeadRerouterProps) => {
  const { data, isLoading } = api.account.details.useQuery();
  const [emailVerified, setEmailVerified] = useState(false);
  const [redirectTo, setRedirectTo] = useState<string | null>(PATHS.STUDENT_DETAILS_PATH);

  const handleVerifyEmail = useCallback(async () => {
    console.log('[debug] handleVerifyEmail ', { email: data?.email });
    const result = await AuthService.verifyEmail({ email: data?.email });
    console.log('[debug] handleVerifyEmail result ', { result });
    if (result.status === 'EXTERNAL_PROVIDER' || data?.status === 'Nurture') {
      console.log('[debug] redirect to signup ', { a: result.status, b: data?.status });
      setRedirectTo(`${PATHS.ROOT_PATH}?oauthSignup=true&email=${data?.email}`);
    }
    setEmailVerified(true);
  }, [data?.email, data?.status]);

  console.log('[debug] LeadRerouter ', { data, isLoading });
  useEffect(() => {
    console.log('[debug] LeadRerouter effect ', { data });
    handleVerifyEmail();
  }, [data, handleVerifyEmail]);

  console.log('[debug] LeadRerouter ', { data, isLoading });
  if (isLoading || !emailVerified) return <FullPageLoader />;

  console.log('[debug] LeadRerouter redirectTo ', { redirectTo });
  if (data && 'userType' in data && data.userType === 'Lead' && emailVerified) {
    return <Redirect to={redirectTo} />;
  }

  return children;
};

export default LeadRerouter;
